import React, { FC, useEffect, useRef } from "react";
import { BulkExportStepper } from "../../../../bulkexport/components/BulkExportStepper";
import { useSubscriptionProviderContext } from "../../../../bulkexport/providers";
import { BulkExportType } from "../../../../bulkexport/components/BulkExportStepper/BulkExportStepper.types";
import { ISubscriptionsSettingsBulkExportProps } from "./SubscriptionsSettingsBulkExport.types";
import isEqual from "lodash/isEqual";

export const SubscriptionsSettingsBulkExport: FC<ISubscriptionsSettingsBulkExportProps> = (props) => {
  const { value, onChange, setApplyPayloadFunction } = props;

  const {
    state: { currentPayload },
    actions: { applyPayload },
  } = useSubscriptionProviderContext();

  const prevPayloadRef = useRef(currentPayload);

  useEffect(() => {
    if (applyPayload) {
      setApplyPayloadFunction((payload) => {
        if ("dimensions" in payload) {
          applyPayload(payload);
        }
      });
    }
  }, [applyPayload]);

  useEffect(() => {
    if (currentPayload && !isEqual(currentPayload, prevPayloadRef.current)) {
      onChange(currentPayload);
      prevPayloadRef.current = currentPayload;
    }
  }, [currentPayload, onChange]);

  return (
    <div>
      <BulkExportStepper item={value} bulkType={BulkExportType.Subscription} />
    </div>
  );
};
